import { GameConfig } from "../../dto/game/GameConfig";
import { GiftGameDTO } from "../../dto/game/GameInitResDto";
import { MemberInfo } from "../../dto/game/MemberInfo";
import gameType, { GameState, IGameAction } from "./game.type";

const initialState: GameState = {
  rewardList: new Array<GiftGameDTO>(),
  memberInfo: null,
  configList: new Array<GameConfig>(),
  gameCode: undefined,
  isVM: false,
  questionInfo: undefined,
  isLoading: false
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: IGameAction) => {
  switch (action.type) {
    case gameType.INFO.LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case gameType.INFO.SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case gameType.INFO.ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case gameType.INIT.LOADING: {
      return {
        ...state,
        isLoading: true,
        rewardList: [],
        memberInfo: {},
      };
    }
    case gameType.INIT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        rewardList: action.payload.giftList as Array<GiftGameDTO> || [],
        memberInfo: action.payload.memberInfo as MemberInfo || {},
        configList: action.payload.configList as Array<GameConfig> || [],
      };
    }
    case gameType.GAME_CODE.SAVE: {
      return {
        ...state,
        gameCode: action.payload,
        isVM: true,
      }
    }
    case gameType.GAME_CODE.CLEAR: {
      return {
        ...state,
        gameCode: undefined
      }
    }
    case gameType.SAVE_SURVEY.LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case gameType.SAVE_SURVEY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case gameType.INIT_SURVEY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        questionInfo: action.payload || {},
      };
    }
    case gameType.UPLOAD_SURVEY.LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case gameType.UPLOAD_SURVEY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
